export default __webpack_public_path__ + "static/icon-truck-28986449354e4e5a819a40b08982d4c6.svg";